import React, { useEffect, useRef, useState } from "react";
import styles from "./Advertisement.module.css";
import { useNavigate } from "react-router-dom";

// const BASE_URL = "https://vitaura.co.in/public/";
const BASE_URL = "https://test.vitaura.co.in/public/";
// const BASE_URL = "https://latest.test.api.vitaura.co.in/public/";
// const BASE_URL = "https://api.vitaura.co.in/";

// const BASE_URL = "https://latest.api.vitaura.co.in/python-api";

const AdvertisementProducts = ({ products = [] }) => {
  const navigate = useNavigate();

  const wrapperRef = useRef(null);
  const sliderRef = useRef(null);

  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (!wrapperRef.current || !sliderRef.current) return;

      const wrapperWidth = wrapperRef.current.offsetWidth;

      // Width of original products only
      const children = [...sliderRef.current.children].slice(
        0,
        products.length,
      );

      let totalWidth = 0;

      children.forEach((child) => {
        totalWidth += child.offsetWidth + 12;
      });

      setShouldScroll(totalWidth > wrapperWidth);
    };

    checkScroll();

    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [products]);

  if (!products.length) return null;

  const displayProducts = shouldScroll ? [...products, ...products] : products;
  const handleProductClick = (item) => {
    navigate(`/productdetails/${item.slug}`);
  };
  return (
    <section className={styles.wrapper} ref={wrapperRef}>
      <div
        ref={sliderRef}
        className={`${styles.slider} ${
          shouldScroll ? styles.animate : styles.noAnimate
        }`}
      >
        {displayProducts.map((item, index) => {
          const originalPrice = Number(item.price);
          const offerPrice = Number(item.offer_price || item.price);

          const discount =
            item.offer_price && originalPrice > offerPrice
              ? Math.round(((originalPrice - offerPrice) / originalPrice) * 100)
              : 0;

          return (
            <div
              className={styles.card}
              key={`${item.id}-${index}`}
              onClick={() => handleProductClick(item)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleProductClick(item);
                }
              }}
            >
              <div className={styles.overlay}></div>

              <div className={styles.content}>
                <h3>{item.name}</h3>

                <div className={styles.priceBox}>
                  <span className={styles.offerPrice}>₹{offerPrice}</span>

                  {item.offer_price && (
                    <>
                      <span className={styles.originalPrice}>
                        ₹{originalPrice}
                      </span>

                      <span className={styles.discount}>{discount}% OFF</span>
                    </>
                  )}
                </div>

                <button
                  className={styles.shopBtn}
                  onClick={() => handleProductClick(item)}
                >
                  Shop Now
                </button>
              </div>

              <div className={styles.imageBox}>
                <img src={`${BASE_URL}${item.thumb_image}`} alt={item.name} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AdvertisementProducts;
